var _style, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPicklist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_548_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_551_",
    d: "M25,0H1C0.45,0,0,0.45,0,1v5.09v1.62v4.47v1.62v4.47v1.62V25c0,0.55,0.45,1,1,1h14.82c0.55,0,1-0.45,1-1 v-5.09v-1.62v-4.47v-1.62V7.72H25c0.55,0,1-0.45,1-1V1C26,0.45,25.55,0,25,0z M15.2,24.38H1.63v-4.47H15.2V24.38z M15.2,18.28 H1.63v-4.47H15.2V18.28z M15.2,12.19H1.63V7.72H15.2V12.19z M24.38,6.09h-7.55H1.63V1.63h22.75V6.09z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_567_",
    cx: 22.69,
    cy: 3.86,
    r: 0.89
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_568_",
    cx: 20.39,
    cy: 3.86,
    r: 0.89
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_569_",
    cx: 18.05,
    cy: 3.86,
    r: 0.89
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicklist);
export default __webpack_public_path__ + "static/media/Picklist.985be042334ea17794fb7c13eceb4f31.svg";
export { ForwardRef as ReactComponent };